import { deliveryBox, priceIcon } from 'assets/icons';
import NotFound from 'common/NotFound';
import useDebounce from 'common/UseDebounce';
import useFullPageLoader from 'common/UseFullPageLoader';
import React, { useEffect, useState } from 'react'
import { FaCoins } from 'react-icons/fa';
import { RiDeleteBin7Line } from 'react-icons/ri';
import { TbTruckDelivery } from 'react-icons/tb';
import Pagination from 'react-js-pagination';
import { Navigate, useSearchParams } from 'react-router-dom';
import { orderHistoryListApi } from 'services/user';
import { dateFormat, formatCustomDate } from 'utils/dateFormat';
import { useNavigate } from "react-router-dom";

const OrderHistory = ({ userId }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loader, onShow, onHide] = useFullPageLoader();
  const search = searchParams.get("search") || "";
  const activePage = searchParams.get("page") || 1;
  const debouncedValue = useDebounce(search, 300);
  const [total, setTotal] = useState(0)
  const [orderHistory, setOrderHistory] = useState([])
  const Navigate = useNavigate(); // outside com
  const limit = 9

  //-------------Handel-Pagination-------------
  const handlePageChange = (event) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", event);
    setSearchParams(newParams);
  };

  // ----------Listing-API-------------------
  useEffect(() => {
    const fetchOrderHistory = async () => {
      const query = {
        page: activePage,
        limit,
        search: '',
      };
      onShow();
      try {
        const res = await orderHistoryListApi(userId, query);
        const { code, data } = res?.data;
        if (code === 200) {
          setOrderHistory(data?.data || []);
          setTotal(data?.total || 0)
        }
      } catch (error) {
        console.log(error);
      } finally {
        onHide();
      }
    };

    if (userId) {
      fetchOrderHistory();
    }
  }, []);

  return (
    <div className="container mt-4">
      {loader}
      <div className="row g-4">
        {orderHistory.length > 0 ? (
          orderHistory?.map((data, index) => {
            return (
              <div className="col-md-4" key={index}>
                <div
                  className="card order-card border shadow-sm"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    Navigate(`/order-management/order-details/${data._id}`)
                  }
                >
                  <div className="card-body">
                    <div className="d-flex justify-content-between mb-2">
                      <div className="fw-semibold">Order ID #{data?.orderId}</div>
                      <div className="order-meta">On {dateFormat(data?.createdAt)}</div>
                    </div>

                    {/* ---- Product list with name, itemType & quantity ---- */}
                    <div className="product-pill mb-3">
                      {data?.products.length > 0 &&
                        data?.products.map((p, i) => (
                          <div
                            key={p._id ? `${p._id}-${i}` : i}
                            className="d-flex justify-content-between align-items-center"
                            style={{ fontSize: "0.85rem" }}
                          >
                            <span>
                              {p.name}
                              {p.itemType && (
                                <span className="badge bg-light text-dark border ms-2">
                                  {p.itemType}
                                </span>
                              )}
                            </span>
                            <span className="text-muted ms-2">
                              Qty: {p.quantity}
                            </span>
                          </div>
                        ))}
                    </div>

                    {data?.deliveryDate &&
                      <div className="d-flex align-items-center mb-2">
                        <img className="bi bi-box-seam me-2 text-muted" src={deliveryBox} alt="delivery" />
                        <span className="text-dark">Delivered on {formatCustomDate(data?.deliveryDate, 'MMM-DD HH:mmA')} </span>
                      </div>}

                    <div className="d-flex align-items-center mb-3">
                      <img className="bi bi-box-seam me-2 text-muted" src={priceIcon} alt="price" />
                      <span className="text-dark">Total Price ₹{data?.total}</span>
                    </div>
                  </div>
                  <div className="order-footer">
                    <span className="order-label">Ordered by : {data?.user?.fullName}</span>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <table>
            <tbody>
              <NotFound
                cols={4}
                msg={"order History data not found"}
                onHide={onHide}
                icon={<TbTruckDelivery />}
              />
            </tbody>
          </table>
        )}
      </div>
      {total > limit && (
        <div className="pagination-wrapper">
          <div className="Pagination">
            <Pagination
              activePage={activePage}
              previousLabel={"previous"}
              nextLabel={"next"}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              hideDisabled={true}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default OrderHistory